import { FC } from 'react';
import ReactFlag, { Props as ReactFlagProps } from 'react-flagkit';
import { styled } from '@mui/material';

import {
  Country,
  getFlag,
  LowerCaseSearchLanguage,
  SearchLanguage,
} from '@models/CountriesAndLanguages';

import { Avatar, AvatarProps } from './Avatar';

export const FlagContainer = styled(Avatar)`
  img {
    height: 100%;
    width: auto;
  }
`;

type CommonFlagProps = { alignMiddle?: boolean } & (
  | (Pick<AvatarProps, 'size'> & {
      variant: 'circle';
    })
  | (Pick<ReactFlagProps, 'size'> & {
      variant: 'standard' | undefined;
    })
);

export type GeneralFlagProps = CommonFlagProps & {
  country: string;
};

export const GeneralFlag: FC<GeneralFlagProps> = ({ size, country, variant, alignMiddle }) =>
  variant === 'circle' ? (
    <FlagContainer size={size}>
      <ReactFlag country={country} />
    </FlagContainer>
  ) : (
    <ReactFlag
      country={country}
      size={size}
      style={alignMiddle ? { verticalAlign: 'middle' } : undefined}
    />
  );

export type FlagProps = CommonFlagProps & {
  country: Country | LowerCaseSearchLanguage | SearchLanguage;
};

export const Flag: FC<FlagProps> = ({ country, ...rest }) => (
  <GeneralFlag country={getFlag(country)} {...rest} />
);
